"use client";

import { c as _c } from "react/compiler-runtime";
import Cleave from "cleave.js/react";
import { ReactInstanceWithCleave } from "cleave.js/react/props";
import { forwardRef, useEffect, useRef, useState } from "react";
import TextField from "../TextField";
import { TextFieldProps } from "../TextField/types";
export type NumberFieldProps = {
  format?: boolean;
  germanLocale?: boolean;
  autoDefaultValue?: number;
} & TextFieldProps;
const NumberField = forwardRef<NumberFieldProps, any>(function NumberField(t0, ref) {
  const $ = _c(30);
  let autoDefaultValue;
  let onBlur;
  let onChange;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      onChange,
      value,
      format: t1,
      germanLocale: t2,
      autoDefaultValue,
      onBlur,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = autoDefaultValue;
    $[2] = onBlur;
    $[3] = onChange;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = value;
  } else {
    autoDefaultValue = $[1];
    onBlur = $[2];
    onChange = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    value = $[7];
  }
  const format = t1 === undefined ? true : t1;
  const germanLocale = t2 === undefined ? true : t2;
  const numeralDecimalMark = germanLocale ? "," : ".";
  const delimiter = germanLocale ? "." : ",";
  const isDecimalMark = useRef(false);
  const [cleave, setCleave] = useState();
  let t3;
  if ($[8] !== numeralDecimalMark || $[9] !== onChange) {
    t3 = event => {
      const number = event.target.rawValue ? Number(event.target.rawValue) : null;
      isDecimalMark.current = event.target.value.endsWith(numeralDecimalMark);
      onChange?.(number);
    };
    $[8] = numeralDecimalMark;
    $[9] = onChange;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleChange = t3;
  let t4;
  if ($[11] !== autoDefaultValue || $[12] !== onBlur || $[13] !== onChange || $[14] !== value) {
    t4 = event_0 => {
      if (autoDefaultValue !== undefined && (value === null || value === undefined || value === "")) {
        onChange?.(autoDefaultValue);
      }
      onBlur?.(event_0);
    };
    $[11] = autoDefaultValue;
    $[12] = onBlur;
    $[13] = onChange;
    $[14] = value;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const handleBlur = t4;
  let t5;
  let t6;
  if ($[16] !== cleave || $[17] !== numeralDecimalMark || $[18] !== value) {
    t5 = () => {
      let rawValue = isNaN(value) ? "" : String(value);
      if (isDecimalMark.current) {
        rawValue = rawValue + numeralDecimalMark;
      }
      cleave?.setRawValue(rawValue);
    };
    t6 = [value, isDecimalMark, cleave, numeralDecimalMark];
    $[16] = cleave;
    $[17] = numeralDecimalMark;
    $[18] = value;
    $[19] = t5;
    $[20] = t6;
  } else {
    t5 = $[19];
    t6 = $[20];
  }
  useEffect(t5, t6);
  const t7 = format ? delimiter : "";
  let t8;
  if ($[21] !== numeralDecimalMark || $[22] !== t7) {
    t8 = {
      numeralDecimalMark,
      delimiter: t7,
      numeral: true
    };
    $[21] = numeralDecimalMark;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== handleBlur || $[25] !== handleChange || $[26] !== props || $[27] !== ref || $[28] !== t8) {
    t9 = <TextField {...props} htmlRef={ref} as={Cleave} value="0" onInit={setCleave} options={t8} onChange={handleChange} onBlur={handleBlur} inputMode="numeric" />;
    $[24] = handleBlur;
    $[25] = handleChange;
    $[26] = props;
    $[27] = ref;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
});
export default NumberField;